import React from "react";
import "./LegalPages.css";

export default function PrivacyPolicy() {
  return (
    <div className="pp-legal-page">
      <div className="pp-container">
        <div className="pp-legal-shell">
          <div className="pp-legal-hero">
            <div className="pp-legal-badge">Privacy Policy</div>
            <h1>Privacy protection for schools, staff and families</h1>
            <p>
              CoreLogic Systems Ltd operates PresentPlus with a data-minimisation
              approach aligned to UK GDPR and the Data Protection Act 2018.
            </p>
          </div>

          <div className="pp-legal-summary">
            <div>
              <span>Role</span>
              <strong>Schools remain Data Controllers</strong>
            </div>
            <div>
              <span>Approach</span>
              <strong>Minimal, school-relevant data</strong>
            </div>
            <div>
              <span>Contact</span>
              <strong>privacy@presentplus.uk</strong>
            </div>
          </div>

          <div className="pp-legal-content">
            <section>
              <h2>1. Overview</h2>
              <p>
                CoreLogic Systems Ltd operates PresentPlus and is committed to protecting
                personal data in accordance with UK GDPR and the Data Protection Act 2018.
              </p>
            </section>

            <section>
              <h2>2. Our Role</h2>
              <p>
                Schools and organisations act as Data Controllers. PresentPlus acts
                primarily as a Data Processor on their behalf.
              </p>
            </section>

            <section>
              <h2>3. Data We Process</h2>
              <ul>
                <li>Student names, class details and attendance records</li>
                <li>Parent names, contact details and linked child access</li>
                <li>Staff accounts, roles and operational activity</li>
                <li>System, security and audit logs</li>
              </ul>
            </section>

            <section>
              <h2>4. Data Minimisation</h2>
              <p>
                PresentPlus is designed to avoid unnecessary personal data and to process
                only what is needed for attendance, communication, reports, behaviour
                and school operations.
              </p>
            </section>

            <section>
              <h2>5. Storage & Security</h2>
              <p>
                Data is stored using secure cloud infrastructure with authentication,
                access control and encryption in transit and at rest.
              </p>
            </section>

            <section>
              <h2>6. Sharing & Rights</h2>
              <p>
                We do not sell personal data. Data is shared only with authorised
                organisations and necessary service providers. Data rights requests
                should normally be made through the relevant school or organisation.
              </p>
            </section>

            <section>
              <h2>7. Contact</h2>
              <p>For privacy questions, contact privacy@presentplus.uk.</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
